<div class="reprocess-wrapper">
  @if (isLoading()) {
    <div class="flex items-center justify-center p-8">
      <p class="text-gray-500">Cargando datos...</p>
    </div>
  } @else if (reprocessForm) {
    <form [formGroup]="reprocessForm" class="form-content">
      <div class="section-card">
        <p class="text-sm text-gray-600 mb-4">
          Código de muestra:
          <span class="font-semibold">{{ specimenCode() }}</span>
        </p>
        <h4 class="section-title">Reprocesos</h4>

        <div class="toggle-container">
          <span class="toggle-label">Tiene reproceso</span>
          <label class="toggle-switch">
            <input type="checkbox" formControlName="hasReprocess" />
            <span class="toggle-slider"></span>
          </label>
        </div>

        @if (isReprocessEnabled()) {
          <div class="form-grid">
            <app-form-dropdown
              label="Causa del reproceso"
              placeholder="Seleccione..."
              [formControl]="causeReprocessIdControl"
              [items]="causeReprocessDropdownOptions()"
            ></app-form-dropdown>

            <app-form-dropdown
              label="Estado"
              placeholder="Seleccione..."
              [formControl]="statusReprocessIdControl"
              [items]="statusReprocessDropdownOptions()"
            ></app-form-dropdown>

            <div class="col-span-full">
              <div class="input">
                <label for="observation" class="input-label-item"
                  >Observación</label
                >
                <textarea
                  id="observation"
                  formControlName="observation"
                  placeholder="Valor relleno"
                  rows="4"
                  class="input-head-item resize-none"
                ></textarea>
              </div>
            </div>
          </div>
        }
      </div>

      <div
        class="flex justify-between gap-4 mt-8 pt-6 border-t border-gray-200"
      >
        <button
          type="button"
          (click)="onCancel()"
          class="px-6 py-3 border-2 border-blue-deep text-blue-deep rounded-lg hover:bg-blue-50 transition-colors font-medium"
        >
          Cancelar
        </button>
        <button
          type="button"
          (click)="onSave()"
          [disabled]="
            !isReprocessEnabled() || reprocessForm.invalid || isSaving()
          "
          class="px-6 py-3 bg-blue-deep text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors font-medium"
        >
          Guardar
        </button>
      </div>
    </form>
  }
</div>
